import { id } from 'postcss-selector-parser';
import priceDataTable from 'core-lib/components/priceDataTable/priceDataTable.vue'

export default {
  props: [
    'data',
    'search',
    'extraServicesData'
  ],
  watch: {
    data: function(v) {
      this.loadData()
    }
  },
  computed: {
    totalPaxs: function() {
      return (this.search.adults + this.search.minors + this.search.infants)
    }
  },
  components: {
    priceDataTable,
  },
  data() {
    return {
      SSA: '1- TOTAL AMOUNTS',
      taxesLoaded: false,
      feesLoaded: false,
      totalFareBase: 0,
      totalTaxes: 0,
      totalDetailTaxes: {},
      totalFeesCharges: 0,
      totalDetailFeesCharges: {},
      faresEquivalentPaidByPtc: [],
      totalToPay: 0,
      paxTypes: ['ADULT', 'MINOR', 'INFANT'],
      paxTypeShow: ''
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.setSummaryShowAmounts()
      this.setTotalFareBase()
      this.setTotalTaxes()
      this.setTotalDetailTaxes()
      this.setTotalFeesCharges()
      this.setTotalDetailFeesCharges()
      this.setFaresEquivalentPaidByPtc()
      // this.handleTotalTaxes()
      this.setTotalToPay()
    },
    handleTotalTaxes () {
      this.totalDetailTaxes = this.data.total_taxes
    },
    setSummaryShowAmounts () {
      var jj = this.$store.getters.getGeneralSettings
      if (jj.ecommerce_setup && jj.ecommerce_setup.summary_show_amount) {
        this.SSA = jj.ecommerce_setup.summary_show_amount
        if (this.totalPaxs === 1) {
          this.paxTypeShow = 'ADULT'
        }
      }
    },
    handleEquivalentPaid () {
      this.totalFareBase = this.data.total_equivalent_paid
    },
    setTotalFareBase () {
      // const totalPaxQty = this.search.adults + this.search.minors + this.search.infants

      this.totalFareBase = this.data.total_equivalent_paid
    },
    setTotalTaxes () {
      this.totalTaxes = this.data.taxes.total_taxes
    },
    setTotalFeesCharges () {
      this.totalFeesCharges = this.data.fees.total_fees
    },
    getPriceExtraServices () {
      if (this.extraServicesData && this.extraServicesData.total) {
        return this.extraServicesData.total
      } else {
        return 0
      }
    },
    getFlightsExtraServices() {
      let extraServices = []
      if (this.extraServicesData.journey) {
        let flightsOriginDestinationInformation =  Object.values(this.extraServicesData.journey.flights_origin_destination_information.flights_origin_destinations)
        flightsOriginDestinationInformation.forEach(data=>{
          data.services_group_list.forEach(service=> {
            extraServices.push(service)
          })
          Object.values(data.flights_segment_information).forEach(segment=> {
            if (segment.services_group_list) {
              segment.services_group_list.forEach(serviceInSegment=>{
                  serviceInSegment.sevices_list.forEach(serviceListSegment=>{
                    extraServices.push(serviceListSegment)
                  })
              })
            }
          })
        });
      }

      return extraServices
    },
    setTotalDetailTaxes () {
      // this.handleSumGroupItem('taxes', 'totalDetailTaxes')

      this.paxTypes.forEach((paxType) => {
        const paxTaxes =
          this.data.taxes.taxes_detail.find(x => x.passenger_type == paxType ||
            (paxType == 'MINOR' && x.passenger_type == 'CHILD'  ))
        if (paxTaxes) {
          const paxQty = paxTaxes.passenger_quantity
          this.totalDetailTaxes[paxType] = []
          if(paxTaxes.taxes_list.length){
            paxTaxes.taxes_list.forEach((taxItem) => {
              let tax = {
                currency_reference_id: taxItem.currency_reference_id,
                code: taxItem.tax_code,
                amount: taxItem.amount * paxQty
              }
              this.totalDetailTaxes[paxType].push(tax)
            })
          }
        }
      })

      this.taxesLoaded = true
    },
    setTotalDetailFeesCharges () {
      // this.handleSumGroupItem('taxes', 'totalDetailTaxes')

      this.paxTypes.forEach((paxType) => {
        const paxFees =
          this.data.fees.fees_detail.find(x => x.passenger_type == paxType ||
            (paxType == 'MINOR' && x.passenger_type == 'CHILD'  ))
        if (paxFees) {
          const paxQty = paxFees.passenger_quantity
          this.totalDetailFeesCharges[paxType] = []
          if(paxFees.fees_list.length){
            paxFees.fees_list.forEach((feeItem) => {
              let fee = {
                currency_reference_id: feeItem.currency_reference_id,
                code: feeItem.fee_code,
                amount: feeItem.amount * paxQty
              }
              this.totalDetailFeesCharges[paxType].push(fee)
            })
          }
        }
      })

      this.feesLoaded = true
    },
    setTotalToPay () {
      if (this.data) {
        this.totalToPay = (this.totalFeesCharges+this.totalFareBase+this.totalTaxes)
      }
    },
    handleSumItem (item) {
      let acum = 0
      if (this.data) {
        let paxTypes = this.paxTypes
        let search = this.search
        let data = this.data
        paxTypes.map(function(paxType) {
          if (data[paxType] && data[paxType][item])
            acum+= ((data[paxType][item]) * search[paxType+'s'])
        })
      }
      return acum
    },
    handleSumGroupItem (itemType, destination) {
      if (this.data) {
        let acum = [];
        let search = this.search
        let data = this.data
        let paxTypes = this.paxTypes
        let promiseList = new Promise(function(resolve,reject){
          paxTypes.map(function(paxType) {
            data.taxes.taxes_detail.find(x => x.passenger_type == paxType).taxes_list

            if (data[paxType] && data[paxType][itemType]) {
              data[paxType][itemType].map(function(value, key) {
                let indexId = acum.map(function(e) { return e.code; }).indexOf(value.code);
                if (indexId >= 0) {
                  acum[indexId]['amount'] = (acum[indexId]['amount'] + value.amount) * search[paxType+'s']
                } else {
                  acum.push({
                    'code': value.code,
                    'amount': value.amount * search[paxType+'s']
                  })
                }
              })
            }
          })
          resolve(acum);
        })
        Promise.all([promiseList]).then((arrList)=>{
          arrList.forEach((array)=>{
            this[destination] = array
          })
        });
      }
    },
    getTransPaxLabel(key) {
      let map = {
        'ADULT': 'adults',
        'MINOR': 'childs',
        'INFANT': 'infants'
      }
      if (map[key]) {
        return map[key].toLowerCase()
      }
      return key.toLowerCase()
    },
    formatNumberToLocale (importe) {
      const numberFormat1 = new Intl.NumberFormat()
      return (numberFormat1.format(importe))
    },
    setFaresEquivalentPaidByPtc () {
      // this.faresEquivalentPaidByPtc = this.data.fares_equivalent_paid_by_ptc
      this.paxTypes.forEach((paxType) => {
        const paxFare =
          this.data.fares_equivalent_paid_by_ptc.find(x => x.passenger_type == paxType ||
            (paxType == 'MINOR' && x.passenger_type == 'CHILD'  ))
        if (paxFare) {
          const paxQty = paxFare.passenger_quantity
          this.faresEquivalentPaidByPtc[paxType] = []
          let fare = {
            passengerQuantity: paxFare.passenger_quantity,
            amount: paxFare.amount
          }
          this.faresEquivalentPaidByPtc[paxType] = fare
        }
      })
    },
    formatNumber (value) {
      return value.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2})
    },
    getTotalTaxesByPtc (ptc) {
      var taxes = this.data.taxes.taxes_detail
      var filter = taxes.filter((x) => x.passenger_type==ptc || (ptc == 'MINOR' && x.passenger_type == 'CHILD'))
      let total = 0
      if (filter[0]) {
        total = filter[0]['total_amount']
      }
      return total
    },
    getTotalFeesByPtc (ptc) {
      var fees = this.data.fees.fees_detail
      var filter = fees.filter((x) => x.passenger_type==ptc || (ptc == 'MINOR' && x.passenger_type == 'CHILD'))
      let total = 0
      if (filter[0]) {
        total = filter[0]['total_amount']
      }
      return total
    },
    getTotalByPtc (ptc) {
      var unit_total = (
        this.getTotalTaxesByPtc(ptc) + this.getTotalFeesByPtc(ptc) + this.faresEquivalentPaidByPtc[ptc].amount
      )
      return (unit_total * this.faresEquivalentPaidByPtc[ptc].passengerQuantity)
        .toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2})
    },
    selectPaxSumm (choice) {
      if (this.totalPaxs > 1) {
        this.paxTypeShow = choice == this.paxTypeShow ? '' : choice
      }
    }
  }
}
